import React from "react";
import logo from "../../assets/images/jayveer-logo.png";
import { Container, Nav, Navbar } from "react-bootstrap";
import { BiMenu } from "react-icons/bi";
import "./Header.scss";

const Header = () => {
  return (
    <>
      <header id="header" className="header fixed-top">
        <Navbar id="navbar" expand="lg" style={{ background: "transparent" }}>
          <Container>
            <Navbar.Brand href="#home" style={{margin: '10px'}}>
              <img
                src={logo}
                alt="Jayveer-jyotish-logo"
                style={{ maxHeight: "60px" }}
              />
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              style={{ padding: 0, border: 0, boxShadow: "none" }}
            >
              <BiMenu
                fontSize={35}
                fill="#ff7010"
                style={{ marginBottom: "12px" }}
              />
            </Navbar.Toggle>
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-end"
              style={{ background: "transparent" }}
            >
              <Nav className="ml-auto" style={{ alignItems: "center" }}>
                <Nav.Link href="#home" className="scrollto">
                  Home
                </Nav.Link>
                <Nav.Link href="#service" className="scrollto">
                  Services
                </Nav.Link>
                <Nav.Link href="#aboutus" className="scrollto">
                  About us
                </Nav.Link>
                <Nav.Link href="#appointment" className="scrollto">
                  Appointment
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
};

export default Header;
